import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_SHARE_LINK_REGIME_RESET = registerFeatureWithDescription({
    numericalId: 24,
    id: "share-link-regime-reset",
    name: "Share-Link Regime Comments Reset",
    internalUseOnly: true,
    descriptionLines: [
        "Allows internal regime editors to clear share-link comments and required-field responses gathered for a maintenance regime.",
    ],
})
